@if ((params.shouldShowErrorMsg$ | async) && (params.error$ | async)) {
  @let error = params.error$ | async;
  <div class="center grid-ui-error-container">
    <grid-ui-error
      [errorCode]="error?.errorCode"
      [errorMessage]="error?.errorMessage"
      [errorPrimaryAction]="error?.errorPrimaryAction"
      [errorSecondaryAction]="error?.errorSecondaryAction"
      [showContact]="error?.showContact"
      [contactEmail]="error?.contactEmail"
      (primaryActionClick)="params.loadData()"
      (secondaryActionClick)="reloadApp()"
    >
    </grid-ui-error>
  </div>
}

@if (params.shouldShowLoadingMsg$ | async) {
  <div class="justify-content-center align-items-center loading-container">
    <grid-ui-loading></grid-ui-loading>
  </div>
}

@if (shouldShowNoRowsMsg$ | async) {
  @switch (params.module) {
    @case (modules.alerts) {
      <div class="no-rows-container">
        <div class="icon-wrapper d-flex">
          <svg>
            <use xlink:href="#add-announcement" />
          </svg>
        </div>
      </div>
      <h4 class="mt-4">No alerts created!</h4>
      <button class="btn mc-btn-primary mt-4" [routerLink]="['/country-risk/alerts/create']">
        <i class="fa fa-plus fa-1x mt-1 me-2"></i>
        <span>Create New Alert</span>
      </button>
    }
  }
}
